import {
  AddDiscountCodeRequestedAction,
  addDiscountCodeFailed,
  addDiscountCodeSucceeded
} from '../../carts/cartsSlice';
import {
  ApiAddDiscountCodeFailedAction,
  ApiAddDiscountCodeSucceededAction,
  apiAddDiscountCodeFailedType,
  apiAddDiscountCodeRequested,
  apiAddDiscountCodeSucceededType
} from '@spa/lib/store/api/cart/addDiscountCodeApi';
import { put, race, take } from 'typed-redux-saga';
import { AddDiscountCodeStatus } from '@spa/lib/store/carts/CartsState';
import convertAddDiscountCodeStatus from '@spa/lib/converters/convertAddDiscountCodeStatus';
import convertCartToStateCart from '@spa/lib/converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';

function* addDiscountCodeToCurrentCartSaga({
  payload: { actionId: requestedActionId, customOrderType, discountCode }
}: AddDiscountCodeRequestedAction): Generator {
  const actionId: number = generateActionId();

  yield* put(
    apiAddDiscountCodeRequested({
      actionId,
      customOrderType,
      parentActionId: requestedActionId,
      code: discountCode
    })
  );

  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiAddDiscountCodeSucceededAction>(apiAddDiscountCodeSucceededType),
      failed: take<ApiAddDiscountCodeFailedAction>(apiAddDiscountCodeFailedType)
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded?.payload?.result) {
        const { cart, result } = succeeded.payload.result;

        const discountCodeObj = cart?.discountCodes?.find(
          (appliedDiscountCode) => appliedDiscountCode.code === discountCode
        );

        const maxApplications =
          discountCodeObj?.maxApplications ?? discountCodeObj?.maxApplicationsPerCustomer ?? 2;

        yield* put(
          addDiscountCodeSucceeded({
            cart: cart ? convertCartToStateCart(cart) : null,
            customOrderType,
            requestedActionId,
            discountCode,
            redemptionStatus: convertAddDiscountCodeStatus(result as string),
            isOneTimeDiscountCode: maxApplications <= 1
          })
        );
      } else if (failed !== undefined) {
        yield* put(
          addDiscountCodeFailed({
            requestedActionId,
            discountCode,
            redemptionStatus: AddDiscountCodeStatus.REDEMPTION_ERROR
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default addDiscountCodeToCurrentCartSaga;
